import { TableFilterTabIconName, TableFilterTabIconNames } from '@kuiper/icons';
import { TableFilterTabKey } from '../../../../../common/enums/table-filter-tab-key';
import { TableColumns } from '../../../../../../ui-components/lib/table/table.model';
import {
  RequestSchedule,
  RequestScheduleType,
} from '../../../../../common/models/request-schedule.model';

export const SCHEDULES_TAB_COLUMNS: TableColumns[] = [
  { header: '' },
  {
    header: 'schedules_tab_id_header_title',
    showViewIcon: true,
  },
  {
    header: 'schedules_tab_type_header_title',
  },
  {
    header: 'schedules_tab_next_run_date_header_title',
  },
  {
    header: 'schedules_tab_created_on_header_title',
  },
  {
    header: 'schedules_tab_ends_on_header_title',
  },
  { header: 'schedules_tab_created_by_header_title' },
  { header: 'schedules_tab_status_header_title' },
  { header: '' },
];

export const SCHEDULES_TAB_FILTER_TABS: {
  key: string;
  label: string;
  active: boolean;
  iconName: TableFilterTabIconName;
}[] = [
  {
    key: TableFilterTabKey.ALL,
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: TableFilterTabIconNames.ALL,
  },
];

export const SCHEDULES_TAB_MOCK_DATA: RequestSchedule[] = [
  {
    id: 4829,
    schedule_type: { label: 'Monthly', value: RequestScheduleType.MONTHLY },
    state: { label: 'Active', value: 'active' },
    description: null,
    job: { label: 'Workflow Trigger', value: 'workflow_trigger' },
    start_at: '2025-11-02T18:00:00.000000Z',
    end_at: '2029-01-15T15:45:00.000000Z',
    next_run_at: '2025-11-02T18:00:00.000000Z',
    created_by: {
      id: 10,
      name: 'Alexandra Grant',
      email: undefined,
      image: null,
    },
    cancelled_at: null,
    created_at: '2023-11-10T14:30:00.000000Z',
    updated_at: '2023-11-10T14:30:00.000000Z',
  },
  {
    id: 5731,
    schedule_type: { label: 'Yearly', value: RequestScheduleType.YEARLY },
    state: { label: 'Active', value: 'active' },
    description: null,
    job: { label: 'Workflow Trigger', value: 'workflow_trigger' },
    start_at: '2025-11-02T18:00:00.000000Z',
    end_at: '2029-02-22T22:15:00.000000Z',
    next_run_at: '2025-11-02T18:00:00.000000Z',
    created_by: {
      id: 11,
      name: 'Nina Patel',
      email: undefined,
      image: null,
    },
    cancelled_at: null,
    created_at: '2023-12-15T08:45:00.000000Z',
    updated_at: '2023-12-15T08:45:00.000000Z',
  },
  {
    id: 4830,
    schedule_type: { label: 'One Time', value: RequestScheduleType.ONE_TIME },
    state: { label: 'Cancelled', value: 'cancelled' },
    description: null,
    job: { label: 'Workflow Trigger', value: 'workflow_trigger' },
    start_at: '2025-11-02T18:00:00.000000Z',
    end_at: '2029-02-22T22:15:00.000000Z',
    next_run_at: '2025-11-02T18:00:00.000000Z',
    created_by: {
      id: 11,
      name: 'Nina Patel',
      email: undefined,
      image: null,
    },
    cancelled_at: '2025-11-03T10:00:00.000000Z',
    created_at: '2023-12-15T08:45:00.000000Z',
    updated_at: '2025-11-03T10:00:00.000000Z',
  },
  {
    id: 7953,
    schedule_type: { label: 'Weekly', value: RequestScheduleType.WEEKLY },
    state: { label: 'Inactive', value: 'inactive' },
    description: null,
    job: { label: 'Workflow Trigger', value: 'workflow_trigger' },
    start_at: '2025-11-02T18:00:00.000000Z',
    end_at: '2030-04-30T16:30:00.000000Z',
    next_run_at: '2025-11-02T18:00:00.000000Z',
    created_by: {
      id: 12,
      name: 'Ethan Mitchell',
      email: undefined,
      image: null,
    },
    cancelled_at: null,
    created_at: '2024-02-05T15:00:00.000000Z',
    updated_at: '2024-02-05T15:00:00.000000Z',
  },
  {
    id: 7960,
    schedule_type: { label: 'Daily', value: RequestScheduleType.DAILY },
    state: { label: 'Inactive', value: 'inactive' },
    description: null,
    job: { label: 'Workflow Trigger', value: 'workflow_trigger' },
    start_at: '2025-11-02T18:00:00.000000Z',
    end_at: '2030-04-30T16:30:00.000000Z',
    next_run_at: '2025-11-02T18:00:00.000000Z',
    created_by: {
      id: 12,
      name: 'Ethan Mitchell',
      email: undefined,
      image: null,
    },
    cancelled_at: null,
    created_at: '2024-02-05T15:00:00.000000Z',
    updated_at: '2024-02-05T15:00:00.000000Z',
  },
];
